import { render, staticRenderFns } from "./NotModule.vue?vue&type=template&id=89554f6c&scoped=true&"
import script from "./NotModule.vue?vue&type=script&lang=js&"
export * from "./NotModule.vue?vue&type=script&lang=js&"
import style0 from "./NotModule.vue?vue&type=style&index=0&id=89554f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89554f6c",
  null
  
)

export default component.exports